import { MdOutlineFileDownload } from "react-icons/md";

const Item = ({ name, size, onDownload }) => {
  return (
    <div className="miltis-recap__document-item">
      <div className="miltis-recap__document-item--content">
        <span className="miltis-recap__document-item--name">{name}</span>
      </div>
      <button
        className="miltis-recap__document-item--download"
        onClick={onDownload}
      >
        <MdOutlineFileDownload size={15.6} />
      </button>
    </div>
  );
};
export default Item;
